import React from 'react'
import { browserName } from 'lib/bowser'
import Image from 'components/image'
import { CHROME, FIREFOX, IE, SAFARI } from 'shared/constants'

const CLOUDINARY_BASE_URL = '//res.cloudinary.com/babylist/image/upload/q_auto'

const chromeWindowsInstructions = (
  <span>
    At the top right of your Chrome browser, click the "More" icon{' '}
    <Image
      src={`${CLOUDINARY_BASE_URL}/v1502212074/ic_more_vert_grey600_24dp_zghppr.svg`}
      width="18"
      height="18"
      alt="More"
    />
    . Select <b>Bookmarks</b> and then <b>Show Bookmarks Bar</b>
  </span>
)
const chromeMacInstructions = (
  <span>
    In Chrome's top menu, go to <b>View</b> and make sure there's a checkmark
    next to <b>Always Show Bookmarks Bar</b>.
  </span>
)
const firefoxWindowsInstructions = (
  <span>
    At the top right of your Firefox browser, click the menu icon{' '}
    <Image
      src={`${CLOUDINARY_BASE_URL}/v1619102794/icons/firefox_hamburger_menu_button.png`}
      width="18"
      height="18"
      alt="Menu"
    />{' '}
    and choose <b>Customize...</b> At the bottom of the screen, click{' '}
    <b>Toolbars > Bookmarks Toolbar</b> and make sure there's a checkmark next
    to <b>Always Show</b>.
  </span>
)
const firefoxMacInstructions = (
  <span>
    In Firefox's menu, go to <b>View > Toolbars > Bookmarks Toolbar</b> and make
    sure there's a checkmark next to <b>Always Show</b>.
  </span>
)
const safariInstructions = (
  <span>
    In Safari's menu, go to <b>View > Show Favorites Toolbar</b> (if it says
    "Hide Favorites Toolbar" you're all set).
  </span>
)
const iEinstructions = (
  <span>
    Right-click on the top side of the Internet Explorer window and make sure
    that <b>Favorites bar</b> is checked.
  </span>
)
const defaultInstructions = (
  <span>Check that your browser&apos;s Favorites bar is showing.</span>
)

const chromeWindowsInstallationGif = `${CLOUDINARY_BASE_URL}/v1523999173/windows-chrome-button_vxcyon.gif`
const chromeMacInstallationGif = `${CLOUDINARY_BASE_URL}/v1523999172/bl-bookmarklet-chorme-mac_wbiwog.gif`
const firefoxInstallationGif = `${CLOUDINARY_BASE_URL}/v1523999172/bl-bookmarklet-firefox-mac_thy2qx.gif`
const safariInstallationGif = `${CLOUDINARY_BASE_URL}/v1523999172/bl-bookmarklet-safari_ipbs6g.gif`
const ieInstallationGif = `${CLOUDINARY_BASE_URL}/v1523999173/bl-bookmarklet-ei-button_jme0kk.gif`

const usageGif = `${CLOUDINARY_BASE_URL}/v1537392364/discovery/button-usage.gif`

export const instructionsForBrowser = ({ browser, isWindows }) => {
  switch (browser) {
    case CHROME:
      return {
        instructions: isWindows
          ? chromeWindowsInstructions
          : chromeMacInstructions,
        installationGif: isWindows
          ? chromeWindowsInstallationGif
          : chromeMacInstallationGif,
        usageGif,
        bookmarksBarTitle: 'Bookmarks',
      }
    case FIREFOX:
      return {
        instructions: isWindows
          ? firefoxWindowsInstructions
          : firefoxMacInstructions,
        installationGif: firefoxInstallationGif,
        usageGif,
        bookmarksBarTitle: 'Bookmarks',
      }
    case SAFARI:
      return {
        instructions: safariInstructions,
        installationGif: safariInstallationGif,
        usageGif,
        bookmarksBarTitle: 'Favorites',
      }
    case IE:
      return {
        instructions: iEinstructions,
        installationGif: ieInstallationGif,
        usageGif,
        bookmarksBarTitle: 'Favorites',
      }
    default:
      return {
        instructions: defaultInstructions,
        installationGif: firefoxInstallationGif,
        usageGif,
        bookmarksBarTitle: 'Bookmarks',
      }
  }
}

export const bookmarksBarTitle = () =>
  instructionsForBrowser({ browser: browserName }).bookmarksBarTitle
